/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationChannelUpdateListEntry
 */
export interface NotificationChannelUpdateListEntry {
    /**
     * 
     * @type {string}
     * @memberof NotificationChannelUpdateListEntry
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationChannelUpdateListEntry
     */
    preference_type_id?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationChannelUpdateListEntry
     */
    type?: NotificationChannelUpdateListEntryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannelUpdateListEntry
     */
    value: boolean;
}


/**
 * @export
 */
export const NotificationChannelUpdateListEntryTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    App: 'app'
} as const;
export type NotificationChannelUpdateListEntryTypeEnum = typeof NotificationChannelUpdateListEntryTypeEnum[keyof typeof NotificationChannelUpdateListEntryTypeEnum];


/**
 * Check if a given object implements the NotificationChannelUpdateListEntry interface.
 */
export function instanceOfNotificationChannelUpdateListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function NotificationChannelUpdateListEntryFromJSON(json: any): NotificationChannelUpdateListEntry {
    return NotificationChannelUpdateListEntryFromJSONTyped(json, false);
}

export function NotificationChannelUpdateListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationChannelUpdateListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'preference_type_id': !exists(json, 'preference_type_id') ? undefined : json['preference_type_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': json['value'],
    };
}

export function NotificationChannelUpdateListEntryToJSON(value?: NotificationChannelUpdateListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'preference_type_id': value.preference_type_id,
        'type': value.type,
        'value': value.value,
    };
}

